<script>
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import { createCompanySearchDataSource, COMPANY_SEARCH_MIN_CHARS } from '@/helpers/company-search';

    export default {
        name: 'CompanySearchSelect',
        components: { DxSelectBox },
        props: {
            modelValue: { default: null },
            inputId: { type: String, default: 'companySearch' },
            placeholder: { type: String, default: 'Type at least 3 letters…' }
        },
        emits: ['update:modelValue'],
        data() {
            return {
                companiesDs: createCompanySearchDataSource(),
                minSearchLength: COMPANY_SEARCH_MIN_CHARS
            };
        },
        computed: {
            selected: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit('update:modelValue', value);
                }
            }
        }
    };
</script>

<template>
    <DxSelectBox
        :id="inputId"
        v-model="selected"
        :data-source="companiesDs"
        display-expr="name"
        :search-enabled="true"
        search-mode="contains"
        :search-timeout="300"
        :min-search-length="minSearchLength"
        :show-data-before-search="false"
        :placeholder="placeholder"
        :show-clear-button="true"
        :accept-custom-value="false"
    />
</template>